// KPI 성과 점수 계산 (순수 — DB/shell 무관, 단위 테스트 용이)

import { parseFormula } from './parser.js'
import { evaluateFormula } from './evaluator.js'
import { builtinFunctions, FormulaFunctionMap } from './functions.js'

export interface ScoreResult {
  score: number
  calculationMethod: 'formula' | 'lookup'
}

/** grades lookup table 한 구간. */
export interface GradeBand {
  minValue: number
  maxValue: number
  score: number
}

/**
 * scoreFormula 로 성과 점수 계산. 수식에는 변수 `value`(측정값)만 제공된다.
 * 결과가 유효한 수치가 아니면 null. (파싱/평가 예외는 호출측에서 처리)
 */
export async function scoreFromFormula(
  scoreFormula: string | null | undefined,
  value: number,
  functions: FormulaFunctionMap = builtinFunctions
): Promise<ScoreResult | null> {
  if (!scoreFormula) return null

  const ast = parseFormula(scoreFormula)
  const provider = {
    get: async (name: string) => (name === 'value' ? value : null)
  }
  const result = await evaluateFormula(ast, { functions, provider })

  if (result !== null && result !== undefined && !isNaN(result)) {
    return { score: Number(result), calculationMethod: 'formula' }
  }
  return null
}

/**
 * grades lookup table 로 성과 점수 변환. value 가 속한 [minValue, maxValue] 구간의 score.
 * @deprecated scoreFormula 로 대체 권장.
 */
export function scoreFromLookup(grades: GradeBand[] | null | undefined, value: number): ScoreResult | null {
  if (!grades || grades.length === 0) return null
  const grade = grades.find(g => value >= g.minValue && value <= g.maxValue)
  return grade ? { score: grade.score, calculationMethod: 'lookup' } : null
}
